import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "CO2",
  "use": "CO2-usage",
  "viewBox": "0 0 20 12.46",
  "content": "<symbol viewBox=\"0 0 20 12.46\" id=\"CO2\"><title>CO2</title><path d=\"M10.59,10.4a.86.86,0,0,0-.86.86V13a.86.86,0,0,0,1.72,0V11.26a.86.86,0,0,0-.86-.86Zm0,0\" transform=\"translate(0 -3.77)\" /><path d=\"M17,8.29a4.67,4.67,0,0,0-9-1.69A2.77,2.77,0,0,0,4,9H3.63a3.62,3.62,0,0,0-.1,7.25H16.14A4,4,0,0,0,17,8.29ZM8.8,13.48a1.54,1.54,0,0,1-1.42,1,1.53,1.53,0,0,1-1.52-1.52V11.31a1.52,1.52,0,0,1,2.89-.66.31.31,0,0,1-.56.27.9.9,0,0,0-1.72.38v1.64a.9.9,0,0,0,.9.9.92.92,0,0,0,.85-.59.31.31,0,0,1,.4-.18.32.32,0,0,1,.18.4ZM12.08,13a1.49,1.49,0,0,1-3,0V11.25a1.49,1.49,0,0,1,3,0Zm1.76,1.56h-1a.3.3,0,0,1-.29-.22c-.08-.25.13-.63.65-1.16l0,0c.29-.22.35-.45.31-.57a.18.18,0,0,0-.18-.13c-.08,0-.1,0-.11,0a.35.35,0,0,0-.06.25.31.31,0,0,1-.28.33.3.3,0,0,1-.33-.28,1,1,0,0,1,.22-.72.71.71,0,0,1,.56-.23.8.8,0,0,1,.77.55,1.13,1.13,0,0,1-.5,1.25,3.93,3.93,0,0,0-.28.31h.52a.3.3,0,0,1,.32.3.31.31,0,0,1-.31.31Zm0,0\" transform=\"translate(0 -3.77)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/CO2.svg
// module id = d0dh
// module chunks = 264